@if (missingConfig) {
  <span class="text-red-500">
    {{ 'common.missingtranslation' | translate }} {{ params['key'] }}
  </span>
} @else if (displayValues) {
  <div class="flex flex-col">
    @for (val of displayValues; track val) {
      <div [tooltip]="val | translate">
        {{ val | translate }}
      </div>
    }
  </div>
} @else {
  <span class="text-slate-300">-</span>
}
